import React from 'react'
import Stars from '../Stars'
import styles from './styles.module.scss'

type StarRatingsProps = {
  averageScore: number
  totalReviews?: number
}

const StarRatings = ({
  averageScore = 0,
  totalReviews = 0
}: StarRatingsProps) => {
  return (
    <div className={styles.starRating}>
      <Stars value={averageScore} />
      <p className={styles.totalReview}>({totalReviews})</p>
    </div>
  )
}

export default StarRatings
